import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineSupport } from 'react-icons/hi';
import './FloatingSupportButton.scss';

interface FloatingSupportButtonProps {
  theme: 'light' | 'dark';
}

const FloatingSupportButton: React.FC<FloatingSupportButtonProps> = ({ theme }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

    if (isAuthenticated) {      navigate('/dashboard/tickets');
    } else {
      navigate('/login', { state: { from: '/dashboard/tickets' } });
    }
  };

    return (
    <button className={`floating-support-btn ${theme}`} onClick={handleClick} dir="rtl" aria-label="پشتیبانی " title="پشتیبانی و تیکت‌ها">
      <HiOutlineSupport className="support-icon" />
      <span>پشتیبانی </span>
    </button>
  );
};

export default FloatingSupportButton;